module.exports = __webpack_public_path__ + "static/media/m_property.29658b8b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/m_property.csv
// module id = 936
// module chunks = 0